import { SELECT_DEALER } from 'constants/ActionTypes';
import { SEARCH, SORT } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';

import { SELECT_GROUP } from 'modules/groups/actionTypes';
import * as types from 'modules/statistics/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const emptyState = {
  [SEARCH]: null,
  [SORT]: 'acceptedAmount,desc',
};

/** @type {FilterAdapter<PaymentsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_PROACTIVE_WORKS_FILTER]: filterAdapter.setFilter,
  [SELECT_DEALER]: filterAdapter.resetFilters,
  [SELECT_GROUP]: filterAdapter.resetFilters,
});
